import React from 'react'
import MuiIconButton from '@mui/material/IconButton'
import { ButtonProps } from '@mui/material/Button/Button'

export interface IProps extends ButtonProps {
  icon: React.ReactNode,
  ariaLabel?: string,
}

const IconButton: React.FC<IProps> = (props) => {
  const {
    icon,
    ariaLabel,
    ...rest
  } = props

  return (
    <MuiIconButton aria-label={ariaLabel} {...rest}>
      {icon}
    </MuiIconButton>
  )
}

export default IconButton
